import 'css-chunk-1JavaScriptSource/components/_PanelDesigner/tageditor/TagEditorTextbox.module.scss';export default {
  "tagEditor": "_tagEditor_xfcyz_1"
};